// actions

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const REMOVE_TOAST_FROM_STATE = 'REMOVE_TOAST_FROM_STATE';

// action creators

/**
 * Add a toast programmatically.
 * @param {object} toast - the toast with props to render
 * @example
 * ```
 * const myToast = toast(<MyComponent />, {autoClose: false});
 * addToast(myToast);
 * ```
 */
export const addToast = (toast = {}) => ({
    type: ADD_TOAST,
    payload: toast
});

/**
 * Remove a toast programmatically.
 * @param {string} id - id of the toast to remove
 * @example
 * ```
 * // generate a toast
 * const myToast = toast((<div><button></</div>), {autoClose: false});
 *
 * // add the toast
 * addToast(myToast);
 *
 * // remove the toast
 * removeToast(myToast.id);
 * ```
 */
export const removeToast = (id) => ({
    type: REMOVE_TOAST,
    payload: {id}
});

// Internal action creator to remove toast from state once
// it has removed itself from the UI.
export const removeToastFromState = (id) => ({
    type: REMOVE_TOAST_FROM_STATE,
    payload: {id}
});

// only expose public action creators by default
export default {
    addToast,
    removeToast
};
